export const agreementTitles = [
  {
    id: '1',
    title: 'scopeOfCommunicationTitle',
    description: 'scopeOfCommunicationDescription',
  },
  {
    id: '2',
    title: 'methodOfCommunication',
    description: 'methodOfCommunicationDescription',
  },
  {
    id: '3',
    title: 'howToWithdraw',
    description: 'howToWithdrawDescription',
  },
  {
    id: '4',
    title: 'howToUpdate',
    description: 'howToUpdateDescription',
  },
  {
    id: '5',
    title: 'hardware',
    description: 'hardwareDescription',
  },
  {
    id: '6',
    title: 'paperCopy',
    description: 'paperCopyDescription',
  },
  {
    id: '7',
    title: 'communicationInWriting',
    description: 'communicationInWritingDescription',
  },
  {
    id: '8',
    title: 'federalLaw',
    description: 'federalLawDescription',
  },
  {
    id: '9',
    title: 'termination',
    description: 'terminationDescription',
  },
  {
    id: '10',
    title: 'consent',
    description: 'consentDescription',
  },
];

export const scope = [
  {
    id: '1',
    title: 'scopeOfCommunicationDescriptionOne',
  },
  {
    id: '2',
    title: 'scopeOfCommunicationDescriptionTwo',
  },
  {
    id: '3',
    title: 'scopeOfCommunicationDescriptionThree',
  },
  {
    id: '4',
    title: 'scopeOfCommunicationDescriptionFour',
  },
  {
    id: '5',
    title: 'scopeOfCommunicationDescriptionFive',
  },
  {
    id: '6',
    title: 'scopeOfCommunicationDescriptionSix',
  },
  {
    id: '7',
    title: 'scopeOfCommunicationDescriptionSeven',
  },
];

export const hardware = [
  {
    id: '1',
    title: 'hardwareOne',
  },
  {
    id: '2',
    title: 'hardwareTwo',
  },
  {
    id: '3',
    title: 'hardwareThree',
  },
  {
    id: '4',
    title: 'hardwareFour',
  },
];
export const hardwareWeb = [
  {
    id: '1',
    title: 'hardwareThreeA',
  },
  {
    id: '2',
    title: 'hardwareThreeB',
  },
  {
    id: '3',
    title: 'hardwareThreeC',
  },
];
